import React from 'react';
import { useLanguage } from '../translations/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { language, changeLanguage } = useLanguage();

  const languages = [
    { code: 'en', label: 'EN', name: 'English' },
    { code: 'fr', label: 'FR', name: 'Français' },
    { code: 'es', label: 'ES', name: 'Español' }
  ];

  return (
    <div className="flex items-center gap-1 bg-white/80 rounded-full px-2 py-1 border border-border-light">
      <Globe size={16} className="text-muted mr-1" />
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => changeLanguage(lang.code)}
          className={`px-3 py-1 rounded-full text-sm font-medium transition-all ${
            language === lang.code
              ? 'bg-accent-primary text-white'
              : 'text-muted hover:text-primary hover:bg-accent-wash'
          }`}
          title={lang.name}
          data-testid={`lang-switch-${lang.code}`}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
